import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { deleteSupplierResponsiblePerson } from './deleteSupplierResponsiblePerson';
import { type DeleteSupplierResponsiblePersonMutationOptions } from './types';

/**
 * React Query based custom hook for removing a responsible person from a
 * supplier relationship.
 *
 * Invalidates the supplier detail query for the affected data exchange ID on settle.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/delete_supplier_responsible_person_suppliers__de_id__responsible_persons__user_id__delete
 */
export const useMutationDeleteSupplierResponsiblePerson = (
  options?: DeleteSupplierResponsiblePersonMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ deId, userId }) =>
      deleteSupplierResponsiblePerson(deId, userId),
    onSettled(_data, _error, { deId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getDetail(deId),
      });
    },
    throwOnError: false,
    ...options,
  });
};
